import { useEffect, useState } from 'react';

export default function SearchTermFilter({list, setList, filterBy, searchInputPlaceholder}) {
    const [searchTerm, setSearchTerm] = useState("");
    useEffect(()=>{
        const filtered = searchTerm==="" ? 
        list : 
        list.filter((item)=>{
            return filterBy?.name && item.name.includes(searchTerm.trim()) ||
            filterBy?.email && item.email.includes(searchTerm.trim()) ||
            filterBy?.phone && item.phone.includes(searchTerm.trim()) ||
            filterBy?.city && item.city.includes(searchTerm.trim()) ||
            filterBy?.address && item.address.includes(searchTerm.trim()) ||
            filterBy?.title && item.title.includes(searchTerm.trim())
        })
        setList(filtered);
    },[searchTerm,list])
    return (
        <input style={{width: "40vw" ,minWidth: "350px" ,height: "40px" ,borderRadius: "12px" ,fontSize: "18px" ,textIndent: "10px" ,margin: "0 auto 40px"}} type='search' placeholder={searchInputPlaceholder}  onChange={(e)=>{setSearchTerm(e.target.value)}}/>
    )
}
